// extracted by mini-css-extract-plugin
export default {"root":"Avatar_root__I7hlW","active":"Avatar_active__DUToq","image":"Avatar_image__zR9mP","clickable":"Avatar_clickable__nCAUN","icon":"Avatar_icon__+vfkU"};